import { CallApi, handleJSONResponse } from './common';
import NotificationItemConnection from '@common/types/notifications/notification-item-connection';

const callAPI = CallApi('notifications');

export const list = async (
  token?: string
): Promise<NotificationItemConnection> => {
  const response = await callAPI(
    `/${token ? `?nextToken=${token}` : ''}`,
    'GET'
  );

  return handleJSONResponse(response);
};

export const read = async (): Promise<NotificationItemConnection> => {
  const response = await callAPI(`/read`, 'POST');

  return handleJSONResponse(response);
};

export const clear = async (
  id?: string
): Promise<NotificationItemConnection> => {
  const response = await callAPI(id ? `/clear?id=${id}` : '/clear', 'PUT');

  return handleJSONResponse(response);
};
